"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGroupedFilesByType = exports["default"] = void 0;
var _FileTypes = _interopRequireDefault(require("./constants/FileTypes"));
var getGroupedFilesByType = exports.getGroupedFilesByType = function getGroupedFilesByType(files) {
  var images = [];
  var other = [];
  var signatures = [];
  if (files) {
    files.forEach(function (file) {
      if (file.deleted) return;else if (file.type === _FileTypes["default"].signature) signatures.push(file);else if (/\.png|\.jpg|\.jpeg/gi.test(file.name)) images.push(file);else other.push(file);
    });
  }
  return {
    images: images,
    signatures: signatures,
    other: other
  };
};
var _default = exports["default"] = {
  getGroupedFilesByType: getGroupedFilesByType
};